import $ from 'jquery';

export default class SystemSwitcher {
	constructor() {
		this.systemSwitcher = $('.system-switcher');
	}

	init() {
		this.systemSwitcher.on('click', function () {
			$(this).siblings().removeClass('system-switcher_active');
			$(this).addClass('system-switcher_active');
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/system-switcher/index.js